/* eslint-disable import/no-anonymous-default-export */

import apiCall from "./apiCall";

export default {
 
  async fetchPhoneDetails(phoneNumber) {
    let data = {
      phone_number: phoneNumber,
    };
    let response = await apiCall("application/gymapp/identify_phone", data);
    return response;
  },
  async fetchMembershipTypes() {
    let response = await apiCall("application/gymapp/list_membership_types", []);
    return response;
  },

  async registerCustomer(data) {
    let response = await apiCall("application/gymapp/register", data);
    return response;
  },

  async payMembership(data) {
    let response = await apiCall("application/gymapp/pay_membership", data);
    return response;
  },

  async fetchClasses() {
    let response = await apiCall("application/gymapp/list_classes", []);
    return response;
  },

  async fetchScheduledClasses() {
    let response = await apiCall("application/gymapp/list_scheduled_classes", []);
    return response;
  },

  async startNewSession(data) {
    let response = await apiCall("application/gymapp/new_session", data);
    return response;
  },
  
  async fetchDailySessionActivity() {
    let response = await apiCall("application/gymapp/list_daily_sessions", []);
    return response;
  },
  
  async endGymSession(memberId) {
    let data = {
      member_id: memberId,
    };
    let response = await apiCall("application/gymapp/end_session", data);
    return response;
  },

  async searchMember(search) {
    let data = {
      search: search,
    };
    let response = await apiCall("application/gymapp/search_member", data);
    return response;
  },
  async fetchRecentMembers() {
    let response = await apiCall("application/gymapp/recent_members", []);
    return response;
  },

  async fetchFrequentMembers() {
    let response = await apiCall("application/gymapp/frequent_members", []);
    return response;
  },
  async fetchSessionPrice(memberId, sessionType) {
    let data = {
      member_id: memberId,
      session_type: sessionType,
    };
   
    let response = await apiCall("application/gymapp/session_price", data);
    return response;
  },

  async fetchGymConfig() {
    let response = await apiCall("application/gymapp/list_config", []);
    return response;
  },

  async setConfig(configCode, configValue){
    
    const data={
        "config_code": configCode,
        "config_value": configValue
    }
    let response = await apiCall("application/gymapp/configure", data);
    return response;
 },

 async fetchCustomerListing(data){
    let response = await apiCall("application/gymapp/member_listing", data);
    return response;
  },


  async fetchCustomerCount(){
    let response = await apiCall("application/gymapp/customer_count", []);
    return response;
  },


  async fetchInvoiceListing(data){
    let response = await apiCall("application/gymapp/sale_invoices", data);
    return response;
  },

  async fetchMonthlyRevenue(){
    let response = await apiCall("application/gymapp/monthly_revenue", []);
    return response;
  },

  async fetchDailySessionCount(){
    let response = await apiCall("application/gymapp/daily_session_count", []);
    return response;
  },

  async createTrainer(data){
    let response = await apiCall("application/gymapp/add_trainer", data);
    return response;
  },

  async fetchActiveTrainers(data){
    let response = await apiCall("application/gymapp/active_trainers", data);
    return response;
  },
 
  async fetchAvatarLibrary(){
    let response = await apiCall("application/gymapp/gym_avatars", []);
    return response;
  },

  async fetchFrequentClasses(){
    let response = await apiCall("application/gymapp/frequent_classes", []);
    return response;
  },

  async fetchCommissionBalances(){
    let response = await apiCall("application/gymapp/commission_balances", []);
    return response;
  },

  async payTrainerCommission(data){
    let response = await apiCall("application/gymapp/pay_commission", data);
    return response;
  },

  async createClass(data){
    let response = await apiCall("application/gymapp/new_class", data);
    return response;
  },
  async scheduleClass(data){
    let response = await apiCall("application/gymapp/schedule_class", data);
    return response;
  },


};

